'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(t, o) {
    if (null == t) return {};
    var e, r, n = _object_without_properties_loose(t, o);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);
        for(r = 0; r < i.length; r++)e = i[r], !(o.indexOf(e) >= 0) && Object.prototype.propertyIsEnumerable.call(t, e) && (n[e] = t[e]);
    }
    return n;
}
function _object_without_properties_loose(t, o) {
    if (null == t) return {};
    var e, r, n = {}, i = Object.keys(t);
    for(r = 0; r < i.length; r++)e = i[r], o.indexOf(e) >= 0 || (n[e] = t[e]);
    return n;
}
const ModalDialogButtons = renderWithRef('ModalDialogButtons', null, (e, r)=>{
    var { children: n } = e;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: r,
        props: _object_without_properties(e, [
            "children"
        ]),
        classNames: [
            'swan-modal-dialog-buttons'
        ],
        children: n
    });
});

export { ModalDialogButtons };
